import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import AdminRoleService, { IAdminRoleInfo } from '../../service/admin/AdminRoleService';

export enum AdminRole {
  operationsAdmin = 1,
  projectAdmin = 2,
  superAdmin = 1000,
  commonAdmin = 100,
  sales = 10,
  default = null,
}

interface AdminRoleSelectProps {
  onChange?: (value: any) => void;
  roleOptionProps: (value: IAdminRoleInfo[]) => void;
  initialValues?: number | number[];
  multiple?: boolean;
  value?: number | number[];
  filterOption?: (option: IAdminRoleInfo) => boolean;
}

const AdminRoleSelect: React.FC<AdminRoleSelectProps> = ({
  onChange,
  roleOptionProps,
  initialValues,
  multiple = false,
  value,
  filterOption,
}) => {
  const [roleOptions, setRoleOptions] = useState<IAdminRoleInfo[]>([]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      const response = await AdminRoleService.getAdminRole();
      if (isMounted && response && response.data && response.data.adminRoleInfo) {
        setRoleOptions(response.data.adminRoleInfo);
        roleOptionProps(response.data.adminRoleInfo);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [roleOptionProps]);

  return (
    <>
      <Select 
        className="select-admin_role" 
        mode={multiple ? 'multiple' : undefined}
        onChange={onChange} 
        allowClear
        placeholder="请选择权限"
        defaultValue={initialValues ? initialValues : AdminRole.default}
        value={value}
        optionFilterProp="children"
      >
          {roleOptions.filter((option) => (filterOption ? filterOption(option) : true)).map((option) => (
            <Select.Option key={option.roleId} value={option.roleId}>
              {option.roleName}
            </Select.Option>
        ))}
      </Select>
    </>
  );
}

export default AdminRoleSelect;
